import { createContext, useContext } from 'react';
import { useRealtimeGGSwapShiftManager, RealtimeGGSwapShiftManagerOptions } from '../lib/supabase/gg-swap/shifts/realtimeGGSwapShiftManager';

interface RealtimeGGSwapShiftContextType {
  isConnected: boolean;
}

const RealtimeGGSwapShiftContext = createContext<RealtimeGGSwapShiftContextType | undefined>(undefined);

interface RealtimeGGSwapShiftProviderProps extends RealtimeGGSwapShiftManagerOptions {
  children: React.ReactNode;
}

export function RealtimeGGSwapShiftProvider({ children, ...options }: RealtimeGGSwapShiftProviderProps) {
  const { isConnected } = useRealtimeGGSwapShiftManager(options);

  return (
    <RealtimeGGSwapShiftContext.Provider value={{ isConnected }}>
      {children}
    </RealtimeGGSwapShiftContext.Provider>
  );
}

export function useRealtimeGGSwapShift() {
  const context = useContext(RealtimeGGSwapShiftContext);
  if (context === undefined) {
    throw new Error('useRealtimeGGSwapShift must be used within a RealtimeGGSwapShiftProvider');
  }
  return context;
}